"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadConfig = void 0;
const transformer_1 = require("@leavy/validator/lib/base/transformer");
const validator_1 = require("@leavy/validator/lib/base/validator");
function errorFormatter(e) {
    return {
        property: e.property,
        constraints: e.constraints,
        children: e.children.map(errorFormatter),
    };
}
function loadConfig(schema) {
    const config = transformer_1.plainToClass(schema, process.env, { enableImplicitConversion: true, excludeExtraneousValues: true });
    const validationResult = validator_1.validateSync(config);
    if (validationResult.length > 0) {
        const error = new Error("Validation of the configuration has failed: " + JSON.stringify(validationResult.map(errorFormatter), null, 1));
        Object.defineProperty(error, "properties", {
            value: validationResult,
            enumerable: true,
        });
        throw error;
    }
    return config;
}
exports.loadConfig = loadConfig;
//# sourceMappingURL=loader.js.map